/* eslint standard/no-callback-literal:0, react/jsx-handler-names:0 */

import _ from 'lodash'

import app from '../app.jsx'

class FilterUtil {
  onSearchObjects (ident, keyword, excludeIds, qry = {}, callback) {
    if (ident === 'assignee') {
      this._findOptionsUser(keyword, excludeIds, qry, callback)
    } else if (ident === 'contact') {
      this._findOptionsContact(keyword, excludeIds, qry, callback)
    } else if (ident === 'project') {
      this._findOptionsProject(keyword, excludeIds, qry, callback)
    } else if (ident === 'tag') {
      this._findOptionsTag(keyword, excludeIds, qry, callback)
    } else if (ident === 'status') {
      this._findOptionsStatus(keyword, excludeIds, qry, callback)
    } else {
      callback([])
    }
  }

  /* Private functions */
  _findOptionsUser (keyword, excludeIds, qry, callback) {
    const params = {
      query: Object.assign(
        {
          teamId: app.getTeamId(),
          status: 'active',
          $select: ['userId', 'firstName', 'lastName', 'image'],
          $limit: 10,
          $sort: { firstName: 1 }
        },
        qry || {}
      )
    }

    if (keyword) {
      params.query.$or = []
      keyword.split(' ').forEach(name => {
        const pattern = this._cleanSearchKeyword(name)
        params.query.$or.push(
          { firstName: { $regex: pattern, $options: 'i' } },
          { lastName: { $regex: pattern, $options: 'i' } }
        )
      })
    }

    if (excludeIds && excludeIds.length > 0) {
      params.query.userId = { $nin: excludeIds }
    }

    app
      .service('/api/users/team')
      .find(params)
      .then(findRes => {
        const options = []

        if (findRes && findRes.data) {
          findRes.data.forEach(obj => {
            options.push({
              showImage: true,
              imageUrl: obj.imageUrl,
              value: obj.userId,
              label: obj.displayName
            })
          })
        }

        if (callback) {
          callback(options)
        }
      })
      .catch(err => {
        app.debug('FilterUtil::_findOptionsUser() - Error: ', err)
        callback([])
      })
  }

  _findOptionsContact (keyword, excludeIds, qry, callback) {
    const params = {
      query: Object.assign(
        {
          $select: ['company', 'image'],
          $limit: 10,
          $sort: { company: 1 }
        },
        qry || {}
      )
    }

    if (keyword) {
      params.query.company = {
        $regex: this._cleanSearchKeyword(keyword),
        $options: 'i'
      }
    }

    if (excludeIds && excludeIds.length > 0) {
      params.query._id = { $nin: excludeIds }
    }

    app
      .service('/api/contact')
      .find(params)
      .then(findRes => {
        const options = []

        if (findRes && findRes.data) {
          findRes.data.forEach(obj => {
            options.push({
              showImage: true,
              imageUrl: obj.imageUrl,
              value: obj.id,
              label: obj.company
            })
          })
        }

        if (callback) {
          callback(options)
        }
      })
      .catch(err => {
        app.debug('FilterUtil::_findOptionsContact() - Error: ', err)
        callback([])
      })
  }

  _findOptionsProject (keyword, excludeIds, qry, callback) {
    const params = {
      query: Object.assign(
        {
          $select: ['title'],
          $limit: 10,
          $sort: { title: 1 }
        },
        qry || {}
      )
    }

    if (keyword) {
      params.query.title = {
        $regex: this._cleanSearchKeyword(keyword),
        $options: 'i'
      }
    }

    if (excludeIds && excludeIds.length > 0) {
      params.query._id = { $nin: excludeIds }
    }

    app
      .service('/api/project')
      .find(params)
      .then(findRes => {
        const options = []

        if (findRes && findRes.data) {
          findRes.data.forEach(obj => {
            options.push({
              showImage: false,
              imageUrl: '',
              value: obj.id,
              label: obj.title
            })
          })
        }

        if (callback) {
          callback(options)
        }
      })
      .catch(err => {
        app.debug('FilterUtil::_findOptionsProject() - Error: ', err)
        callback([])
      })
  }

  _findOptionsTag (keyword, excludeIds, qry, callback) {
    const params = {
      query: Object.assign(
        {
          objectType: 'project',
          $limit: 10,
          $sort: { title: 1 }
        },
        qry || {}
      )
    }

    if (keyword) {
      params.query.title = {
        $regex: this._cleanSearchKeyword(keyword),
        $options: 'i'
      }
    }

    if (excludeIds && excludeIds.length > 0) {
      params.query.title = { $nin: excludeIds }
    }

    app
      .service('/api/tag')
      .find(params)
      .then(res => {
        const options = []

        const tagsData = _.uniqBy(res.data, tagObj => tagObj.title)
        tagsData.forEach(obj => {
          options.push({
            showImage: false,
            imageUrl: '',
            value: obj.title,
            label: obj.title
          })
        })

        callback(options)
      })
      .catch(err => {
        app.debug('FilterUtil::_findOptionsTag() - Error: ', err)
        callback([])
      })
  }

  _findOptionsStatus (keyword, excludeIds, qry, callback) {
    const options = []
    const pattern = new RegExp(`.*${keyword}.*`)

    if (
      (!excludeIds || excludeIds.indexOf('open') === -1) &&
      pattern.test('Open')
    ) {
      options.push({
        showImage: false,
        imageUrl: '',
        value: 'open',
        label: 'Open'
      })
    }

    if (
      (!excludeIds || excludeIds.indexOf('closed') === -1) &&
      pattern.test('Closed')
    ) {
      options.push({
        showImage: false,
        imageUrl: '',
        value: 'closed',
        label: 'Closed'
      })
    }

    callback(options)
  }

  _cleanSearchKeyword (keyword) {
    return keyword
      .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
      .replace(/\$/g, '$$$$')
  }
}

export default new FilterUtil()
